export default __webpack_public_path__ + "static/loading-77096b82297a780fc94666fba6f7b093.webm";